import {NgModule} from '@angular/core';
import {GnAppRootComponent} from './app-root.component';
import {RouterModule} from '@angular/router';


@NgModule({
  declarations: [GnAppRootComponent],
  exports: [
    GnAppRootComponent
  ],
  imports: [
    RouterModule
  ]
})
export class GnAppRootModule {
}
